// Centralized route paths for the Kodeo app
// Update these constants if you need to change a route path

const ROUTES = {
    ADMIN: '/admin',
    ADMIN_UNITS: '/admin/units',
    ADMIN_STATS: '/admin/stats',
    ADMIN_CREATOR: '/admin/creator',
    ADMIN_CHARITY_CODES: '/admin/charity-codes',

    LESSON: '/lesson/:unitNum/:conceptNum',
    LESSONS: '/lessons',
    SUMMARY: '/summary',
    SETTINGS: '/settings',
    SUBSCRIPTION: '/subscription',
    SUBSCRIPTION_SUCCESS: '/subscription/success',

    LOGIN: '/login',
    SIGNUP: '/signup',
    FORGOT_PASSWORD: '/forgot-password',
    UPDATE_PASSWORD: '/update-password',
    AUTH_START: '/auth/start',
    AUTH_CALLBACK: '/auth/callback',
    LANDING: '/',
    NOT_FOUND: '*',

    TERMS: '/terms',
    PRIVACY: '/privacy',
};

export default ROUTES;
